"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeAllyPromotionalBucketFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var TimeAllyPromotionalBucketFactory = /** @class */ (function (_super) {
    __extends(TimeAllyPromotionalBucketFactory, _super);
    function TimeAllyPromotionalBucketFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    TimeAllyPromotionalBucketFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    TimeAllyPromotionalBucketFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    TimeAllyPromotionalBucketFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    TimeAllyPromotionalBucketFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    TimeAllyPromotionalBucketFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return TimeAllyPromotionalBucketFactory;
}(contracts_1.ContractFactory));
exports.TimeAllyPromotionalBucketFactory = TimeAllyPromotionalBucketFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'wallet',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'newStatus',
                type: 'bool',
            },
        ],
        name: 'Authorised',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'source',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'FundsAdded',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'wallet',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'stakingReward',
                type: 'uint256',
            },
        ],
        name: 'StakingReward',
        type: 'event',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'stakingContract',
                type: 'address',
            },
        ],
        name: 'claimReward',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'dayswappers',
        outputs: [
            {
                internalType: 'contract IDayswappers',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'initialize',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'isAuthorized',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'isAuthorized',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'kycDapp',
        outputs: [
            {
                internalType: 'contract IKycDapp',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'nrtManager',
        outputs: [
            {
                internalType: 'contract INRTManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'prepaidEs',
        outputs: [
            {
                internalType: 'contract IPrepaidEs',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'randomnessManager',
        outputs: [
            {
                internalType: 'contract RandomnessManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddress',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddressStrict',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsername',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsernameStrict',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_stakingReward',
                type: 'uint256',
            },
        ],
        name: 'rewardToStaker',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_kycDapp',
                type: 'address',
            },
        ],
        name: 'setKycDapp',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'stakingRewards',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyClub',
        outputs: [
            {
                internalType: 'contract ITimeAllyClub',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyManager',
        outputs: [
            {
                internalType: 'contract ITimeAllyManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyPromotionalBucket',
        outputs: [
            {
                internalType: 'contract ITimeAllyPromotionalBucket',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalPendingRewards',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
            {
                internalType: 'bool',
                name: '_newStatus',
                type: 'bool',
            },
        ],
        name: 'updateAuthorization',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'validatorManager',
        outputs: [
            {
                internalType: 'contract IValidatorManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        stateMutability: 'payable',
        type: 'receive',
    },
];
var _bytecode = '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';
//# sourceMappingURL=TimeAllyPromotionalBucketFactory.js.map